'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Badge } from '@/components/ui/badge'
import { ShoppingCart, Star } from 'lucide-react'
import type { CakeItem } from '@/lib/mock-data'

interface CakeCardProps {
  cake: CakeItem
}

export default function CakeCard({ cake }: CakeCardProps) {
  return (
    <Link href={`/cake/${cake.id}`} className="block">
      <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-pink-50 hover:shadow-md transition-all duration-300 hover:-translate-y-0.5">
        <div className="relative aspect-square bg-gradient-to-br from-pink-50 to-purple-50">
          <Image
            src={cake.image}
            alt={cake.name}
            fill
            className="object-cover"
            sizes="(max-width: 640px) 50vw, 200px"
          />
          <div className="absolute top-2 left-2 flex flex-col gap-1">
            {cake.isHot && (
              <Badge className="bg-red-500 text-white text-[10px] px-1.5 py-0">热卖</Badge>
            )}
            {cake.isSeasonal && (
              <Badge className="bg-orange-500 text-white text-[10px] px-1.5 py-0">限定</Badge>
            )}
            {cake.isNew && !cake.isHot && (
              <Badge className="bg-blue-500 text-white text-[10px] px-1.5 py-0">新品</Badge>
            )}
            {cake.tags.slice(0, 1).map(tag => (
              <Badge key={tag} className="bg-green-500 text-white text-[10px] px-1.5 py-0">{tag}</Badge>
            ))}
          </div>
        </div>
        <div className="p-2.5">
          <h3 className="text-sm font-medium text-gray-800 line-clamp-1 mb-1">{cake.name}</h3>
          <div className="flex items-center gap-2 mb-1.5">
            <div className="flex items-center gap-0.5">
              <Star className="w-3 h-3 text-amber-400 fill-amber-400" />
              <span className="text-[11px] text-gray-500">{cake.rating}</span>
            </div>
            <span className="text-[11px] text-gray-400">月售{cake.monthlySales}+</span>
          </div>
          <div className="flex items-end justify-between">
            <span className="text-base font-bold text-pink-500">¥{cake.minPrice}{cake.maxPrice && cake.maxPrice > cake.minPrice ? '~' + cake.maxPrice : ''}</span>
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
              className="w-6 h-6 rounded-full bg-pink-500 flex items-center justify-center hover:bg-pink-600 transition-colors"
            >
              <ShoppingCart className="w-3 h-3 text-white" />
            </button>
          </div>
        </div>
      </div>
    </Link>
  )
}
